import DOMPurify from "dompurify";

export const sanitizeAndTrimString = (value: string | undefined): string => {
    if (!value) return "";
    return DOMPurify.sanitize(value, { ALLOWED_TAGS: [] }).trim();
};